import produce from 'immer';
import { AbsenceListItemResponse, MetaPagination, ProfileResponse3 } from '../../../api';
import { baseAbsenceRequestsActions } from '../actions';

export interface BaseAbsenceRequestsState {
  list: {
    data: AbsenceListItemResponse[];
    pagination: MetaPagination | undefined;
    ok: boolean | undefined;
  };
  /** Newest pending requests shown on the dashboard tile; `total` is the overall pending count. */
  dashboard: {
    data: AbsenceListItemResponse[];
    total: number;
    ok: boolean | undefined;
  };
  employees: {
    data: ProfileResponse3[];
    ok: boolean | undefined;
  };
}

export const ABSENCE_REQUESTS_INITIAL_STATE: BaseAbsenceRequestsState = {
  list: {
    data: [],
    pagination: undefined,
    ok: undefined,
  },
  dashboard: {
    data: [],
    total: 0,
    ok: undefined,
  },
  employees: {
    data: [],
    ok: undefined,
  },
};

export function BaseAbsenceRequestsReducer(
  state: BaseAbsenceRequestsState = ABSENCE_REQUESTS_INITIAL_STATE,
  action: any
): BaseAbsenceRequestsState {
  return produce(state, (draftState) => {
    switch (action.type) {
      case baseAbsenceRequestsActions.loadAbsenceRequests.type:
        draftState.list.ok = undefined;
        return;

      case baseAbsenceRequestsActions.setAbsenceRequests.type:
        draftState.list.data = action.payload.data || [];
        draftState.list.pagination = action.payload.meta;
        return;

      case baseAbsenceRequestsActions.successAbsenceRequests.type:
        draftState.list.ok = true;
        return;

      case baseAbsenceRequestsActions.errorAbsenceRequests.type:
        draftState.list.ok = false;
        return;

      case baseAbsenceRequestsActions.loadDashboardAbsenceRequests.type:
        draftState.dashboard.ok = undefined;
        return;

      case baseAbsenceRequestsActions.setDashboardAbsenceRequests.type:
        draftState.dashboard.data = action.payload.data || [];
        draftState.dashboard.total = action.payload.meta?.page?.itemsCount || 0;
        return;

      case baseAbsenceRequestsActions.successDashboardAbsenceRequests.type:
        draftState.dashboard.ok = true;
        return;

      case baseAbsenceRequestsActions.errorDashboardAbsenceRequests.type:
        draftState.dashboard.ok = false;
        return;

      case baseAbsenceRequestsActions.loadEmployees.type:
        draftState.employees.ok = undefined;
        return;

      case baseAbsenceRequestsActions.setEmployees.type:
        draftState.employees.data = action.payload;
        return;

      case baseAbsenceRequestsActions.successEmployees.type:
        draftState.employees.ok = true;
        return;

      case baseAbsenceRequestsActions.errorEmployees.type:
        draftState.employees.ok = false;
        return;
    }
  });
}
